import cx from 'classnames';
import { appAssetsCdnUrl } from '~/constants/environment';
import useIsInShaqHomeTakeoverExperiment from '~/hooks/common/experiments/useIsInShaqHomeTakeoverExperiment';
import useGetConsumerHref from '~/hooks/common/selectors/useGetConsumerHref';
import { nativeSrpPayload } from '~/native/common/utils';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';
import optimizeImage from '~/utilities/optimizeImage';
import AffordableCarsGraphic from './AffordableCarsGraphic';
import AffordableCarsShaqGraphic from './AffordableCarsShaqGraphic';
import {
  CardContainer,
  CardCta,
  CardSubtitle,
  CardTitle,
  CardTitleContainer
} from './Cards.styles';

const AFFORDABLE_CARS_SEARCH_LINK = generateSearchLinkFilter({
  filters: { price: { max: 20000 } }
});

export default function AffordableCarsCard() {
  const getHref = useGetConsumerHref();
  const isInShaqExperiment = useIsInShaqHomeTakeoverExperiment();

  const backgroundImageUrl = isInShaqExperiment
    ? optimizeImage(
        `${appAssetsCdnUrl}/images/home/budget-affordable-cars-shaq.png`,
        { format: 'auto', height: 730, quality: 90 }
      )
    : undefined;

  return (
    <CardContainer
      className={cx(
        'bg-background-primary-weak',
        isInShaqExperiment && 'relative bg-cover bg-bottom bg-no-repeat'
      )}
      data-analytics-id="Shop Affordable Cars"
      data-testid="affordable-cars-card"
      data-native-payload={nativeSrpPayload}
      href={getHref(AFFORDABLE_CARS_SEARCH_LINK)}
      style={
        backgroundImageUrl
          ? { backgroundImage: `url(${backgroundImageUrl})` }
          : undefined
      }
    >
      <CardTitleContainer>
        <CardTitle>Cars under $20K</CardTitle>
        <CardSubtitle>
          Great rides with quality you can count on — at a price you’ll love.
        </CardSubtitle>
      </CardTitleContainer>
      {isInShaqExperiment ? (
        <AffordableCarsShaqGraphic />
      ) : (
        <AffordableCarsGraphic />
      )}
      <CardCta data-testid="explore-budget-options">
        Explore Budget Options
      </CardCta>
    </CardContainer>
  );
}
